import { APP_BASE_HREF } from '@angular/common';
import {
  Component,
  EventEmitter,
  Inject,
  Injectable,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { AppService } from '@app/_core/services/app.service';
import { DialerService } from '@app/_core/services/dialer.service';
import { QueuesService } from '@app/_core/services/queues.service';
import { TmQueueService } from '@app/_core/services/tm-queue.service';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { TabView } from 'primeng/tabview';
import { DialerComponent } from 'src/app/_core/components/dialer/dialer.component';
import { ConfirmDialogComponent } from 'src/app/pages/common/confirm-dialog/confirm-dialog.component';
import { FlexibleStoreService } from '@app/_core/services/flexible-storage.service';
//import { CaseDetailComponent } from 'src/app/pages/queue/common/case-detail/case-detail.component';
//import { TransferInternalController } from 'src/app/pages/queue/dialer/TransferInternalController.component';

/*import { AnnouncedTransferComponent } from '../announced-transfer/announced-transfer.component';*/
import { MainControllerComponent } from 'src/app/pages/queue/dialer/MainController.component';
import { WebStorageService } from '@app/_core/services/webstorage.service';
import { WindowsWrapperService } from '@app/_core/services/windows-wrapper.service';
let callerHungUp: boolean = false;
let agentHungUp: boolean = false;
let callers: any = null;
const showConference: boolean = false;
@Injectable({ providedIn: 'root' })
@Component({
  selector: 'app-transfer-window',
  templateUrl: './transfer-window.component.html',
  styleUrls: ['./transfer-window.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class TransferWindowComponent implements OnInit,OnDestroy {
  @ViewChild(TabView) tabView: TabView;
  @Output() SUBMIT_CALL: EventEmitter<any> = new EventEmitter<any>();
  @Output() CallEvent_TRANSFER: EventEmitter<any> = new EventEmitter<any>();
  @Output() CallTransfer_internalCallInProgress: EventEmitter<any> = new EventEmitter<any>();
  @Output() CallTransfer_internalCallEnded: EventEmitter<any> = new EventEmitter<any>();
  @Output() CallTransfer_callerHungUp: EventEmitter<any> = new EventEmitter<any>();
  @Output() CallTransfer_hide: EventEmitter<any> = new EventEmitter<any>();
  //@Output() CallTransfer_TransferController_CLOSE: EventEmitter<any> = new EventEmitter<any>();
  Showdisplay1: boolean = true;
  Showdisplay2: boolean = false;
  Showdisplay3: boolean = false;
  modalRef?: BsModalRef;
  countryCode: any;
  phoneNo: any;
  isFreeDialer:boolean=false;
  filterVal: any;
  internalAgentdata: any = [];
  filteredinternalAgentdata: any = [];
  internalUsers: any = [];
  externalUsers: any = [];
  groups: any = [];
  Groupdata: any = [];
  updateTimer: any;
  updategrpTimer: any;
  updateTimerWait: any = 10000;
  //params:  {};
  external = false;
  noPostCallTimeout = false;
  waitingForCallToComplete = false;
  allowCancel = false;
  onlyComments = false;
  showStep2 = false;
  enterRecordTime = null;
  transferProcessing = false;
  currTransfer: any;
  callers: any;
  disconnectTimeout = null;
  statusFailures = 0;
  waitingPrompt = null;
  dialerType = 'Manual';
  postCallTimeout = 0;
  postCallTimeoutRemaining = 0;
  postCallTimeoutInterval = null;
  requestMoreTimeBtn: any;
  postCallTimeoutAlert: any;
  postCallTimeoutText: any;
  isGroupTransfer = false;
  groupTransferComplete = false;
  commentsOnly = false;
  userdata: any;
  type: any;
  selectedTab: any;

  step2Hdr1Text: any;
  step2Hdr2Text: any;
  isvalueupdated: boolean = false;
  step2ToggleCaller: any = 'test';
  step2ToggleBtn: any = {};
  //step2CompleteBtn: boolean = false;
  step2CompleteBtn: any = {};
  step2CompleteBtn_enabled: any;
  step2CompleteBtn_label: any;
  step2CompleteBtn_tooltip: any;

  step2ToggleBtn_enabled: any;
  step2ToggleBtn_label: any;
  step2ToggleBtn_tooltip: any;

  step2ResumeBtn_enabled: any;
  step2ResumeBtn_label: any;
  step2ResumeBtn_tooltip: any;

  step2ResumeBtn: any = {};
  step2VoicemailBtn: any = {};

  step2VoicemailBtn_enabled: any;
  step2VoicemailBtn_label: any;
  step2VoicemailBtn_tooltip: any;

  step2AgentText: any;
  isGroup: any;
  transferCallID: any;
  onWithCaller: any;
  pendingToggle: any;
  internalCallStart: any;
  title: any;
  step2CallerText: any = {};

  caller: any;
  agent: any;
  completeTransferClicked: boolean = false;
  callConnectedSnd: any = new Audio('https://common.cts-connect.com/Audio/newCallTone-alt.wav');
  forceTransferCancel: any;
  isAway: any;
  queueType: any;
  ShowParticipantList: boolean = false;
  conferenceList: any;
  callersUserCountText: any;
  callersInternalCountText: any;
  callersExternalCountText: any;
  actionItemToReturn: any;
  activityId: any;
  AllowInternalTransfers: boolean = false;
  infoCurrentQueueDetail: any;
    transferCaseID: any;
   
  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private tmQueueService: TmQueueService,
    private queueServices: QueuesService,
    private flexStore: FlexibleStoreService,
    private webStorageService: WebStorageService,
    private dialerComponent: DialerComponent,
    //private transferInternalController: TransferInternalController, // private mainController: MainControllerComponent,
      private mainController: MainControllerComponent,
    private dialerService: DialerService,
    private confirmDialogComponent: ConfirmDialogComponent,
    private appService: AppService,
    private queueService: QueuesService,
    private WindowsWrapper: WindowsWrapperService,
    @Inject(APP_BASE_HREF) public baseHref: string
  ) {
    //this.CallEvent_TRANSFER.subscribe(val => {
    // console.log('CallEvent_TRANSFER Emit');
    // this.eTransferHandler(val.data,val.type);
    //});
      this.tmQueueService.CallTransfer_internalCallInProgress.subscribe(val => {
      // console.log('internalCallInProgress Emit', val);
      //this.bsModalRef.hide();
      //this.initdialog();
          if (val?.value) {
              this.internalCallInProgress(val.caller, val.agent);
              this.tmQueueService.setCallTransfer_internalCallInProgress({ value: false })
          }
    });
    this.dialerService.HideTransferDialogWindow.subscribe(val => {
      if (val) this.hide(val);
    });
    this.queueService.onWithCaller.subscribe(val => {
      this.onWithCaller = val;
    });
    this.dialerService.IsFreeDialer.subscribe(value => {
      this.isFreeDialer = value;
    });
    this.tmQueueService.CallTransfer_internalCallEnded.subscribe(val => {
          if (val?.value) {
             // console.log('internalCallEnded Emit', val);
              //this.bsModalRef.hide();
              //this.initdialog();
              this.internalCallEnded_view(val.InternalCallStatus);
              this.tmQueueService.setCallTransfer_internalCallEnded({ value: false })
          }
    });
      this.tmQueueService.CallTransfer_callerHungUp.subscribe(val => {
          if (val?.value) {
             // console.log('callerHungUp Emit', val);

              this.callerHungUp_funt();
              this.tmQueueService.setCallTransfer_callerHungUp({value:false})
          }
      });
      this.tmQueueService.CallTransfer_Reset.subscribe(val => {
          if (val?.value) {
              //console.log('CallTransfer_Reset Emit', val);

              this.resetTransferdata();
              this.tmQueueService.setCallTransfer_Reset({ value: false })
          }
      });
      this.tmQueueService.CallTransfer_hide.subscribe(val => {
          if (val?.value) {
             // console.log('internalCallEnded Emit', val);
              //this.bsModalRef.hide();
              //this.initdialog();
              this.hide(val);
              this.tmQueueService.setCallTransfer_hide({ value: false })
          }
    });
    this.appService.selectedQueueType.subscribe((type: any) => {
      if (type == 'Inbound') this.step2VoicemailBtn_enabled = true;
      else {
        this.step2VoicemailBtn_enabled = false;
      }
      this.queueType = type;
    });

    this.dialerService.callEnded.subscribe((val: boolean) => {
      if (val) {
        this.closepartcipantlistMenu();
      }
      // if (val) this.hangUp();
    });
    this.dialerService.callDisconnected.subscribe(value => {
      if (value) {
        this.closepartcipantlistMenu();
      }
    });
    this.appService.actionItemId.subscribe(value => {
      this.actionItemToReturn = value;
    });
    this.appService.activityId.subscribe(value => {
      this.activityId = value;
    });
    this.appService.transferCaseID.subscribe(value => {
      this.transferCaseID = value;
    });
    //this.dialerService.isDialerCancel.subscribe((value: any) => {
    //    if (value) {
    //        this.resettimer();
    //    }
    //});
  }
  ngOnDestroy(): void {
    this.removeOverflowHidden();
    this.updateTimer && clearTimeout(this.updateTimer);
    this.updategrpTimer && clearTimeout(this.updategrpTimer);
    this.postCallTimeoutInterval && clearInterval(this.postCallTimeoutInterval);
  }

  ngOnInit(): void {
    this.appService.infoCurrentQueue.subscribe(response => {
      if (response) {
        this.infoCurrentQueueDetail = response;
        this.AllowInternalTransfers = this.infoCurrentQueueDetail.AllowInternalTransfers;
      }
    });
    if (this.ShowParticipantList) {
      this.Showdisplay1 = false;
      this.populateConferenceList();
    } else {
      //if (this.Showdisplay2) {

      //}
      //else {
      this.Showdisplay1 = true;
      this.dialerService.setCurrentTransferStep(1);
        this.queueServices.setistransferProcessing(false);
        if (this.AllowInternalTransfers) {
            this.getInternalTransferDetails();
        }
        else {
            this.getExternalNumbersByActivity();
        }
      this.dialerService.setisCallTransferstarted(true);
      //this.GetAgentStatuses();
    }
  }

  callerHungUp_funt = function () {
    callerHungUp = true;
    this.setCallerDisplay(callerHungUp);
  };

  closeTaskSelectionMenu() {
    this.bsModalRef.hide();
    callerHungUp = false;
    agentHungUp = false;
    this.dialerService.setCurrentTransferStep(0);
    this.queueServices.setistransferProcessing(false);
    this.resettimer();
    this.dialerService.setisCallTransferstarted(false);
  }
    resetTransferdata() {

        callerHungUp = false;
        agentHungUp = false;
        this.dialerService.setCurrentTransferStep(0);
        this.queueServices.setistransferProcessing(false);
        this.dialerService.setisCallTransferstarted(false);
    }
  showDialog() {
    this.Showdisplay2 = true;
  }
  CallTransfer(userdata, type) {
    //  this.visible = true;
    this.userdata = userdata;
    this.type = type;
    this.Showdisplay2 = true;
    console.log('Transfer Type:', type);
  }
    initiateCallTransfer() {
       
        this.removeOverflowHidden();
        //this.eTransferHandler(this.userdata, this.type);
        this.mainController.setcallTransferred(true);
        //this.Showdisplay3 = true;
        //this.disableDialerbuttonsExceptHangup();
        this.resettimer();
        const returnData = {
            activityID: this.activityId,
            actionItem: this.actionItemToReturn,
            isExternalTransfer: this.selectedTab == 'External',
            queueType: this.queueType,
            transferCaseID: this.transferCaseID,
            triggerType: 'PreTransfer'
        };
        this.mainController.setSaveChanges(true);
        this.tmQueueService.setTransfer_SUBMIT_CALL(returnData);
        if (this.selectedTab == 'External')
            this.eTransferHandler(this.userdata ?? { Number: this.countryCode + this.phoneNo }, this.type);
        else if (this.selectedTab == 'Internal' || this.selectedTab == 'Groups')
            this.eTransferHandler(this.userdata, this.type);
       
    
  }
  disableDialerbuttonsExceptHangup = function () {
    const data: any = {};

    data.CustomControlEnabled = true;
    data.muteBtn_enabled = false;
    data.keypadBtn_enabled = false;
    data.holdBtn_enabled = false;
    data.hangUpBtn_enabled = true;
    data.transfersBtn_enabled = false;
    data.conferenceBtn_enabled = false;

    this.dialerService.setCustomShowDialer(data);
  };
    closeModal() {
        
    this.Showdisplay2 = false;
    this.removeOverflowHidden()
  }

  removeOverflowHidden()
  {
    const body=document.body;
    body.classList.remove('p-overflow-hidden');
  }
  // ngOnDestroy() {
  //   this.modalService.onHide.unsubscribe();
  // }
  openAnnouncedTransfer() {
    // this.closeTaskSelectionMenu();
    // this.closeModal();
    //const initialState = {
    //	currTransfer: this.currTransfer,

    //};

    //  const config: ModalOptions = {
    //class: 'transfer-window me-3',
    //backdrop: 'static',
    //keyboard: false,
    //    initialState,
    //  };

    /* this.modalRef = this.modalService.show(AnnouncedTransferComponent, config);*/
    if (this.currTransfer) {
      this.loaddisplayStep2Data(this.currTransfer);
      this.queueServices.setCurrentTransferData(this.currTransfer);
    }
    this.Showdisplay3 = true;
    // this.closeTaskSelectionMenu();
    //this.closeModal();
    // this.modalRef.content.event.subscribe((result: any) => {});
  }

  openAnnouncedTransfer1() {
    // this.closeTaskSelectionMenu();
    // this.closeModal();
    const initialState = {
      currTransfer: this.currTransfer,
    };

    const config: ModalOptions = {
      class: 'transfer-window me-3',
      backdrop: 'static',
      keyboard: false,
      initialState,
    };

    //this.modalRef = this.modalService.show(AnnouncedTransferComponent, config);
    this.closeTaskSelectionMenu();
    this.closeModal();
    // this.modalRef.content.event.subscribe((result: any) => {});
  }

  loaddisplayStep2Data = function (currTransferData) {
    this.dialerService.setCurrentTransferStep(2);
    const data = currTransferData;
    //$(this._cl_viewElement).removeClass('TransferStep1 TransferStep3').addClass('TransferStep2');
    this.title = data != null && data.hasOwnProperty('typeName') ? data.typeName : 'Add to Conference';
    const isAdd = this.title.indexOf('Add ') == 0;
    this.isGroup = data.type == 'groupAnnounced' || data.type == 'groupAttended';
    this.step2Hdr1Text = data != null && data.hasOwnProperty('Name') ? data.Name : 'Third Party';
    this.step2Hdr2Text = this.getUserName();
    this.step2ToggleState_text = 'On with Transfer';
    this.step2ToggleCaller_text = '';
    this.step2ToggleBtn_enabled = false;
    this.step2AgentText = this.isGroup
      ? 'You may complete the transfer<br />once the recipient is on the line.'
      : 'When you are ready,<br />choose one of the following options.';
    this.step2CompleteBtn_enabled = false;
    this.step2CompleteBtn_label = 'Complete ' + (isAdd ? 'Add' : 'Transfer');
    this.step2CompleteBtn_tooltip = isAdd
      ? 'Add the recipient to the conference call.'
      : 'Transfer the user to the recipient.  If Announced, you will be disconnected.  If Attended, you will stay on the line.';
    this.step2ResumeBtn_label = isAdd ? 'Cancel Add' : 'Cancel Transfer';
    this.step2ResumeBtn_tooltip = isAdd
      ? 'Cancel the add and resume your call with the user.'
      : 'Cancel the transfer and resume your call with the user.';
    this.step2VoicemailBtn_visible =
      data != null &&
      data.type != 'externalAttended' &&
      data.type != 'externalAnnounced' &&
      data.type != 'externalAdd' &&
      !this.isGroup;
    this.step2VoicemailBtn_enabled = true;

    currTransferData.step2ToggleBtn_enabled = this.step2ToggleBtn_enabled;
    currTransferData.step2CompleteBtn_enabled = this.step2CompleteBtn_enabled;
    currTransferData.step2CompleteBtn_label = this.step2CompleteBtn_label;
    currTransferData.step2CompleteBtn_tooltip = this.step2CompleteBtn_tooltip;
    currTransferData.step2ResumeBtn_label = this.step2ResumeBtn_label;
    currTransferData.step2ResumeBtn_tooltip = this.step2ResumeBtn_tooltip;
    currTransferData.step2VoicemailBtn_visible = this.step2VoicemailBtn_visible;
    currTransferData.step2VoicemailBtn_enabled = this.step2VoicemailBtn_enabled;
    currTransferData.step2ToggleState = this.step2ToggleState_text;
    currTransferData.step2ToggleCaller = this.step2ToggleCaller_text;

    this.setCallerDisplay(callerHungUp);
    //$(step2AgentText._cl_viewElement).removeClass('flashing');
    //step1.visible(false);
    //step3.visible(false);
    this.transferCallID = null;
    //this.onWithCaller = false;
    this.queueService.setOnWithCaller(false);
    this.pendingToggle = false;
    this.internalCallStart = true;
    //if (this._qbr_modal != null) {
    //	this._qbr_modal.contentView().width(350);
    //this.cl().main().mainController().phoneController().isTransferViewActive(true);
    this.queueServices.setisTransferViewActive(true);

    //	if (this.cl().main().mainController().phoneController().externalSystem())
    //		this._qbr_modal.contentView().alignX('right').alignY('top').x(-10).y(145);
    //}
    //this.width(350).height(420);
    //step2.visible(true);

    this.queueServices.setCurrentTransferData(currTransferData);
  };
  setCallerDisplay = function (hungUp) {
    this.step2CallerText = callerHungUp ? 'THE CALL WITH THE CUSTOMER HAS ENDED.' : '';
    if (hungUp) {
      this.step2CompleteBtn_enabled = false;
      this.step2ToggleBtn_enabled = false;
      //this.step2VoicemailBtn_enabled = false;
    }

      if (callerHungUp && agentHungUp) {
          this.mainController.stopCallDurationTimer();
      //cls.cl().main().mainController().phoneController().stopCallDurationTimer();
    }

    let currTransfer: any = {};
    const CurrentTransferData = this.queueServices.getCurrentTransferData();
    if (CurrentTransferData) currTransfer = CurrentTransferData;

    currTransfer.step2CallerText = this.step2CallerText;
    currTransfer.step2CompleteBtn_enabled = this.step2CompleteBtn_enabled;
    currTransfer.step2ToggleBtn_enabled = this.step2ToggleBtn_enabled;
    //currTransfer.step2VoicemailBtn_enabled = this.step2VoicemailBtn_enabled;
    this.queueServices.setCurrentTransferData(currTransfer);
  };
  getUserName = function () {
    //if (!options.User || !options.User.FullName) {
    //	return "New/Unknown User";
    //}
    const userName = ''; //(options.User.FullName == '') ? options.User.Company : options.User.FullName;
    return userName;
  };
  Getdata(variableName) {
    const currTransfer = this.queueServices.getCurrentTransferData();
    return currTransfer ? currTransfer[variableName] : '';
  }
  internalCallInProgress = function (caller, agent) {
    //if we're in the middle of a group transfer, then allow toggle and complete now that the internal call was answered
    //let currTransfer = this.queueServices.getCurrentTransferData();
    agentHungUp = false;
    let currTransfer: any = {};
    const CurrentTransferData = this.queueServices.getCurrentTransferData();
    if (CurrentTransferData) currTransfer = CurrentTransferData;
    this.step2ToggleCaller = this.onWithCaller ? (caller == null ? '' : caller) : agent == null ? '' : agent;

    currTransfer.step2ToggleCaller = this.step2ToggleCaller;

    if (!this.completeTransferClicked) {
      this.step2CompleteBtn_enabled = true;
      this.step2ToggleBtn_enabled = true;

      currTransfer.step2CompleteBtn_enabled = this.step2CompleteBtn_enabled;
      currTransfer.step2ToggleBtn_enabled = this.step2ToggleBtn_enabled;
    }
    if (this.onWithCaller) {
      //&& self.currentStep() == 2) {
      this.step2AgentText = 'The transfer recipient has answered the call.';
      if (this.internalCallStart) {
        this.internalCallStart = false;
        this.callConnectedSnd.play();
        if (this.transferCallID != null) {
          //self.controller().holdTransferRecipient(transferCallID);
        }
        //$(step2AgentText._cl_viewElement).toggleClass('flashing', true);
      }
    } else {
      this.step2AgentText = 'When you are ready,<br />choose one of the following options.';
      currTransfer.step2AgentText = this.step2AgentText;
    }

    this.queueServices.setCurrentTransferData(currTransfer);
  };

  internalCallEnded_view = function (internalCallStatus) {
    let currTransfer: any = {};
    if (this.queueServices.getCurrentTransferData()) currTransfer = this.queueServices.getCurrentTransferData();

    if (internalCallStatus != 'busy') {
      this.step2ToggleCaller = 'THE CALL WITH THE RECIPIENT HAS ENDED.';
    } else {
      this.step2ToggleCaller = 'THE RECIPIENT IS BUSY.';
    }
    this.step2CompleteBtn_enabled = false;
    this.step2ToggleBtn_enabled = false;
    agentHungUp = true;

    currTransfer.step2CompleteBtn_enabled = this.step2CompleteBtn_enabled;
    currTransfer.step2ToggleBtn_enabled = this.step2ToggleBtn_enabled;
    currTransfer.step2ToggleCaller = this.step2ToggleCaller;

    if (callerHungUp && agentHungUp) {
      //cls.cl().main().mainController().phoneController().stopCallDurationTimer();
        this.mainController.stopCallDurationTimer();
    }
    this.queueServices.setCurrentTransferData(currTransfer);

    //$(step2AgentText._cl_viewElement).removeClass('flashing');
  };
  eStep2ToggleBtnClickHandler = function () {
    if (!this.pendingToggle) {
      this.pendingToggle = true;
      //$(step2AgentText._cl_viewElement).toggleClass('flashing', false);
      this.toggleLines();
    }
  };
  toggleLines = function () {
      var callID = '';//this.queueServices.getCallID();
      if (this.dialerService.getIsFreeDialer()) {
          callID = this.queueServices.getChildCallID();
      }
      else {
          callID = this.queueServices.getCallID();
      }
    const queueID = this.queueServices.getselectedQueueId();
    const transferCallID = this.queueServices.getTransferCallID();
    const GroupTransferInteractionID = this.queueServices.getGroupTransferInteractionID();
    this.currTransfer = this.queueServices.getCurrentTransferData();
    this.currTransfer.step2ToggleBtn_enabled = false;
    this.queueServices.setCurrentTransferData(this.currTransfer);

    this.tmQueueService
      .ToggleLines(callID, queueID, transferCallID, this.onWithCaller, GroupTransferInteractionID)
      .subscribe(response => {
        //this.onWithCaller = response.Response.Data.OnWithCaller;
        this.queueService.setOnWithCaller(response.Response.Data.OnWithCaller);
        this.transferCallID = response.Response.Data.Transfer;
        this.step2ToggleState = this.onWithCaller ? 'On with Caller' : 'On with Transfer';
        this.pendingToggle = false;

        if (this.currTransfer && this.currTransfer?.step2ToggleState) {
          this.currTransfer.step2ToggleBtn_enabled = true;
          this.currTransfer.step2ToggleState = this.step2ToggleState;
          this.queueServices.setCurrentTransferData(this.currTransfer);
        }

        //return response.Response.Data;
      });
  };
  eStep2CompleteBtnClickHandler = function () {
    //this.currTransfer = this.queueServices.getCurrentTransferData();
    //this.currTransfer.step2CompleteBtn_enabled = false;
    //this.queueServices.setCurrentTransferData(this.currTransfer);
    this.Showdisplay3 = false;

    //this.currTransfer = this.queueServices.getCurrentTransferData();
    this.completeTransferClicked = true;
    this.step2CompleteBtn.enabled = false;
    //cls.cl().main().mainController().phoneController().isTransferViewActive(false);
    this.queueServices.setisTransferViewActive(false);
    const data = this.currTransfer;
    if (data.type != 'announced' && data.type != 'attended') {
      //cls.cl().main().mainController().toggleHold(null, false);
    }
    let type = 'blind';
    switch (data.type) {
      case 'attended':
      //cls.cl().main().mainController().phoneController().disableControlAttended();
      //break;
      case 'conference':
        type = 'conference';
        break;
      case 'externalAttended':
        type = 'completeExternalAttended';
        break;
      case 'externalConference':
        type = 'externalConference';
        break;
      case 'announced':
      case 'completeAnnounced':
        type = 'completeAnnounced';
        break;
      case 'externalAnnounced':
      case 'completeExternalAnnounced':
        type = 'completeExternalAnnounced';
        break;
      case 'add':
      case 'externalAdd':
      case 'completeadd':
        type = 'completeadd';
        break;
      case 'groupAnnounced':
      case 'completeGroupAnnounced':
        type = 'completeGroupAnnounced';
        break;
      case 'groupAttended':
        type = 'completeGroupAttended';
        //cls.cl().main().mainController().phoneController().disableControlAttended();
        break;
      case 'completeGroupAttended':
        type = 'completeGroupAttended';
        break;
    }
    //var transferCallID = this.queueServices.getTransferCallID();

    if (this.transferCallID != null && this.transferCallID != '') {
      //self.dispatchEvent(im.CallEvent.RESUME, { id: transferCallID, skipHide: true, isGroup: isGroup, step2Cancel: false });
      this.tmQueueService.resumeCall(this.transferCallID, false, false, '').subscribe(data => {
        //            console.log(data);
      });
    }
    //self.dispatchEvent(im.CallEvent.TRANSFER, { id: data.id, type: type, name: data.name, step2Cancel: false });
    //this.transferWindowComponent.CallEvent_TRANSFER.emit({ data: this.currTransfer, type: type, step2Cancel: false });
    this.eTransferHandler(this.currTransfer, type);
    //callerHungUp = false;
    //agentHungUp = false;
    //this.dialerService.setCurrentTransferStep(0);
    this.dialerService.setisCallTransferstarted(false);
    if (type == 'completeadd') {
        //   this.queueService.SetDisableHeader(false);
        agentHungUp = false;
        this.dialerComponent.toggleHold.emit({ val: false, shouldcallapi: true });
    }
  };
  applyFilterByField(searchval: any) {


        const t = searchval?.toLowerCase().trim();
        if (!t) {
            this.filteredinternalAgentdata = this.internalAgentdata;
            return;
        }
        this.filteredinternalAgentdata = this.internalAgentdata.filter(a =>
            
            a.Name.toLowerCase().includes(t) 
           
        );

    }

    getInternalTransferDetails() {

        this.getAgentStatuses().then(data => {
            this.internalAgentdata = data;
            this.applyFilterByField(this.filterVal);
            this.updateTimer = setTimeout(this.getInternalTransferDetails.bind(this), 3000);
        });
    }
  getGroupDetails() {
    // window.clearTimeout(this.updategrpTimer);
    // window.clearTimeout(this.updateTimer);
    this.tmQueueService.getAgentGroupStatuses(this.queueServices.getselectedQueueId()).subscribe(data => {
      this.Groupdata = data.Response.Data;
      this.updategrpTimer = setTimeout(this.getGroupDetails.bind(this), 3000);
    });
  }
  //getAgentStatuses() {
  //    window.clearTimeout(this.updateTimer);
  //    this.tmQueueService.getAgentStatuses().subscribe(data => {
  //        this.internalAgentdata = data.Response.Data;
  //        this.updateTimer = setTimeout(this.getAgentStatuses.bind(this), 3000);
  //    })
  //}
  GetAgentStatuses() {
    //this.internalUsers = [
    //  {
    //    UserID: 19253,
    //    Name: 'Ranjithkumar Shanmugam',
    //    StatusID: 8,
    //    Status: 'PostCall',
    //    QueueLength: 0,
    //    SkillFlag: 0,
    //  },
    //  {
    //    UserID: 106807,
    //    Name: 'John Christofer Tungol',
    //    StatusID: 3,
    //    Status: 'Disconnected',
    //    QueueLength: 0,
    //    SkillFlag: 0,
    //  },
    //  {
    //    UserID: 130629,
    //    Name: 'Tejaswini abbindinaga',
    //    StatusID: 6,
    //    Status: 'InQueue',
    //    QueueLength: 0,
    //    SkillFlag: 0,
    //  },
    //];

    this.externalUsers = [
      {
        UserID: 19253,
        Name: 'Srinivas Ramdas',
        StatusID: 8,
        Phone: '1534567890',
        QueueLength: 0,
        SkillFlag: 0,
      },
      {
        UserID: 106807,
        Name: 'Nina Duffy',
        StatusID: 3,
        Phone: '1264567890',
        QueueLength: 0,
        SkillFlag: 0,
      },
      {
        UserID: 130629,
        Name: 'Lok Chetri',
        StatusID: 6,
        Phone: '2345687991',
        QueueLength: 0,
        SkillFlag: 0,
      },
    ];

    this.groups = [
      {
        Name: 'Onboard - First Time Login',
        QueueLength: 8,
        SkillFlag: 0,
      },
      {
        Name: 'Payroll Allowances',
        QueueLength: 3,
        SkillFlag: 0,
      },
    ];
  }

  eTransferHandler = function (agentData, type) {
    //console.warn("TransferController.eTransferHandler(" + e.data().type + ", " + e.data().id + ", " + e.data().name + ")");
    const data = agentData;
    let confirmMessage = null; // "This will save any changes you've made.  Would you like to continue?";
    let method = null;
    const params: any = {};
    //let params: { skillID?: string } = {};
    //var external = false;
    //var noPostCallTimeout = false;
    //var waitingForCallToComplete = false;
    //var allowCancel = false;
    //var onlyComments = false;
    //var showStep2 = false;
    //var enterRecordTime = null;

    if (
      this.queueServices.getistransferProcessing() &&
      type.indexOf('complete') != 0 &&
      type != 'voicemail' &&
      type != 'conference' &&
      type != 'externalConference'
    )
      return;

    const lastTransfer = this.queueServices.getistransferProcessing() && type == 'voicemail' ? agentData : null;

    //this.transferProcessing = true;
    this.queueServices.setistransferProcessing(true);
    //var dialogController = im.DialogController.instance();
    //if (dialogController) {
    //	dialogController.cancelUserSelectOnTransfer();
    const enterTime = this.queueServices.getEnterRecordTime();
    this.enterRecordTime = enterTime ? enterTime.getTime() : null;
    //}
    //this.params.type = type;
      var callID = '';//this.queueServices.getCallID();
      if (this.dialerService.getIsFreeDialer()) {
          callID = this.queueServices.getChildCallID();
      }
      else {
          callID = this.queueServices.getCallID();
      }
    this.currTransfer = data;
    data.type = type;
    params.callID = callID;// this.queueServices.getCallID();
    switch (data.type) {
      case 'skillTransfer':
        method = 'SkillTransfer';
        params.skillID = data.skillID;
        break;
      case 'blind':
        if (this.isCallerOnCall(data.UserID) == true) {
          this.attendTransfer(data.UserID);
          return;
        }
        method = 'BlindTransferToUser';
        params.userID = data.UserID;
        params.enterRecordTime = this.enterRecordTime;
        break;

      case 'announced':
        if (this.isCallerOnCall(data.UserID) == true) {
          this.attendTransfer(data.UserID);
          return;
        }
        method = 'AnnounceTransferToUser';
        params.userID = data.UserID;
        this.showStep2 = true;
        this.currTransfer.typeName = 'Announced Transfer';
        break;

      case 'completeAnnounced':
        method = 'CompleteAnnouncedTransfer';
        params.userID = data.UserID;
        params.enterRecordTime = this.enterRecordTime;
        this.noPostCallTimeout = true;
        confirmMessage = null;
        this.showStep2 = false;
        break;

      case 'attended':
        if (this.isCallerOnCall(data.UserID) == true) {
          this.attendTransfer(data.UserID);
          return;
        }
        method = 'AttendTransferToUser';
        params.userID = data.UserID;
        this.showStep2 = true;
        this.currTransfer.typeName = 'Attended Transfer';
        break;

      case 'conference':
        method = 'CompleteAttendedTransfer';
        params.userID = data.UserID;
        params.enterRecordTime = this.enterRecordTime;
        confirmMessage = null;
        this.waitingForCallToComplete = true;
        this.onlyComments = true;
        this.showStep2 = false;
        break;

      case 'voicemail':
        method = 'SendToVoicemail';
        params.userID = data.UserID;
        params.enterRecordTime = this.enterRecordTime;
        this.noPostCallTimeout = true;
        this.showStep2 = false;
        confirmMessage = null;
        this.waitingForCallToComplete = false;
        this.onlyComments = false;
        break;

      case 'add':
        method = 'AddUserToCall';
        params.userID = data.UserID;
        params.isExternal = false;
        this.showStep2 = true;
        confirmMessage = null;
        this.currTransfer.typeName = 'Add to Conference';
        break;

      case 'completeadd':
        //interactionService.CompleteAddCaller();
        //var phoneController = self.cl().main().mainController().phoneController();
        //phoneController.toggleHoldUI(true);
        //self.hide();
       // var callID = this.queueServices.getCallID();
        var queueID = this.queueServices.getselectedQueueId();
        this.tmQueueService.CompleteAddCaller(callID, queueID).subscribe(data => {});
        this.hideAllDialog();
        this.bsModalRef.hide();
        this.dialerService.setCurrentTransferStep(0);
        this.currTransfer = null;
        this.queueServices.setistransferProcessing(false);
        return;

      case 'externalBlind':
        method = 'BlindTransfer';
        params.number = data.Number;
        this.noPostCallTimeout = true;
        this.external = true;
        break;

      case 'externalAnnounced':
        method = 'ExternalAnnounceTransfer';
        params.number = data.Number;
        this.showStep2 = true;
        this.external = true;
        params.isExternal = true;
        this.currTransfer.typeName = 'Announced Transfer';
        break;

      case 'completeExternalAnnounced':
        method = 'CompleteExternalAnnouncedTransfer';
        params.number = data.Number;
        params.enterRecordTime = this.enterRecordTime;
        this.noPostCallTimeout = true;
        confirmMessage = null;
        this.showStep2 = false;
        this.external = true;
        break;

      case 'externalAttended':
        method = 'ExternalAttendTransfer';
        params.number = data.Number;
        params.isExternal = true;
        this.showStep2 = true;
        this.external = true;
        this.currTransfer.typeName = 'Attended Transfer';
        break;

      case 'externalConference':
        method = 'CompleteExternalAttendedTransfer';
        params.number = data.id;
        params.enterRecordTime = this.enterRecordTime;
        this.waitingForCallToComplete = true;
        confirmMessage = null;
        this.onlyComments = true;
        break;

      case 'externalAdd':
        method = 'AddNumberToCall';
        params.number = data.Number;
        params.isExternal = true;
        this.showStep2 = true;
        confirmMessage = null;
        this.external = true;
        this.currTransfer.typeName = 'Add to Conference';
        break;
      case 'groupBlind':
        method = 'StartGroupTransfer';
        params.transferGroupID = data.TransferGroupID;
        params.blind = true;
        params.transferType = 'GroupBlind';
        this.showStep2 = false;
        break;
      case 'groupAnnounced':
        method = 'StartGroupTransfer';
        params.transferGroupID = data.TransferGroupID;
        this.showStep2 = true;
        params.transferType = 'GroupAnnounced';
        this.currTransfer.typeName = 'Announced Transfer';
        break;
      case 'groupAttended':
        method = 'StartGroupTransfer';
        params.transferGroupID = data.TransferGroupID;
        this.showStep2 = true;
        this.currTransfer.typeName = 'Attended Transfer';
        params.transferType = 'GroupAttended';
        break;
      case 'completeGroupAnnounced':
        method = 'CompleteGroupTransfer';
        params.enterRecordTime = this.enterRecordTime;
        params.groupInteractionid = this.queueServices.getGroupTransferInteractionID();
        this.noPostCallTimeout = true;
        confirmMessage = null;
        this.showStep2 = false;
        break;
      case 'completeGroupAttended':
        method = 'CompleteGroupTransfer';
        params.attended = true;
        params.enterRecordTime = this.enterRecordTime;
        params.groupInteractionid = this.queueServices.getGroupTransferInteractionID();
        confirmMessage = null;
        this.waitingForCallToComplete = true;
        this.onlyComments = true;
        this.showStep2 = false;
        break;
      case 'completeExternalAttended':
        method = 'CompleteExternalAttendedTransfer';
        params.number = data.Number;
        params.enterRecordTime = this.enterRecordTime;
        this.noPostCallTimeout = true;
        this.waitingForCallToComplete = true;
        confirmMessage = null;
        this.external = true;
        this.showStep2 = false;
        this.onlyComments = true;
        break;
    }

    //var debug = "";
    //debug += "Free Dialer:\t" + currOptions.RelatedCall + "\n";
    //debug += "Type:\t" + data.type + "\n";
    //debug += "ID:\t" + (data.id || data.skillID) + "\n";
    //debug += "Confirm:\t" + (confirmMessage != null) + "\n";
    //debug += "External:\t" + external + "\n";
    //debug += "NoTimeout:\t" + noPostCallTimeout + "\n";
    //debug += "Waiting:\t" + waitingForCallToComplete + "\n";
    //debug += "AllowCancel:\t" + allowCancel + "\n";
    //debug += "OnlyComments:\t" + onlyComments + "\n";
    //debug += "Show Step:\t" + ((showStep2) ? 2 : 3) + "\n";

    //console.warn(debug);
    this.dialerService.setwaitingForCallToComplete(this.waitingForCallToComplete);
  //  console.log('While transfering CALLID:' + this.queueServices.getCallID());
    if (confirmMessage == null) {
      if (this.showStep2) {
        //	self.view().hideAll();
        this.hideAllDialog();
      }
      this.completeTransfer(params, method);
    } else {
      //this.confirmAndSave(completeTransfer);
    }
  };

  hideAllDialog() {
    //this.bsModalRef.hide();
    this.Showdisplay1 = false;
    this.Showdisplay2 = false;
    this.Showdisplay3 = false;
    this.ShowParticipantList = false;
  }

  hide(forceTransferCancel) {
    if (
      this.currTransfer == null ||
      this.currTransfer.typeName != 'Attended Transfer' ||
      forceTransferCancel === true
    ) {
      //this.transferProcessing = false;
      this.queueServices.setistransferProcessing(false);
    }
    //if (this.view().display()) {
    //	this.view().display(false);
    //this.dispatchEvent(im.TransferController.CLOSE);

    this.hideAllDialog();
    this.bsModalRef.hide();
    this.enableAddNew();
    this.eTransferCloseHandler();
    const transferCallID = this.queueServices.getTransferCallID();

    if (transferCallID && transferCallID != '') {
      this.queueServices.setTransferCallID('');
    }
    this.queueServices.setGroupTransferInteractionID('');
    this.dialerService.setisCallTransferstarted(false);
    //this.CallTransfer_TransferController_CLOSE.emit();
    //}
  }
  eTransferCloseHandler = function () {
    this.showTransfers(false);
    //if (this.isAway)
    //	cls.cl().main().mainController().showAwayBlockerContent(true, false);
  };

  showTransfers = function (newTransfersState) {
    //if (this.transfersEnabled()) {
    //if (typeof newTransfersState === 'boolean') {
    //	if (newTransfersState == transfersOpen)
    //		return;
    //	transfersOpen = newTransfersState;
    //} else
    //	transfersOpen = !transfersOpen;
    //if (transfersOpen && keypadOpen)
    //	this.showKeypad(false);
    //if (transfersOpen && conferenceOpen)
    //	this.showConference(false);
    //if (transfersOpen || callActive) {
    //	moveToFront();
    //	$(transfersBtn._cl_viewElement).addClass('selected');
    //}
    //else {
    //	moveToBack();
    //	$(transfersBtn._cl_viewElement).removeClass('selected');
    //}
    //cls.toggleFullWidth(!transfersOpen);
    //$('#' + this.instanceUID()).toggleClass('transfersOpen', transfersOpen);
    //}
  };

  enableAddNew = function () {
    this.transferBtn_enabled = true;
    //addNewBtn.enabled(hasUserInfo);
  };
  confirmAndSave(callback) {
    //initAlertModal();
    //alertModal.open(confirmMessage, function () {
    //	if (data.type == "attended") {
    //		dialogController.startHoldTimer();
    //		isTransferCompleteProcessing = true;
    //	}
    //	if (this.showStep2)
    //		self.view().hideAll();
    //	self.saveChanges(callback, external);
    //}, function () {
    //	var currStep = self.view().currentStep();
    //	if (currStep == 1) {
    //		this.currTransfer = null;
    //		this.transferProcessing = false;
    //	} else if (currStep == 2 && data.type == 'voicemail') {
    //		this.currTransfer = lastTransfer;
    //	}
    //});
  }

  completeTransfer(params, method) {
    this.tmQueueService.CallTransfer(params, method).subscribe(
      data => {
        if (method == 'CompleteGroupTransfer' || 
            params.transferType == 'GroupBlind' || 
            method == 'BlindTransferToUser' || 
            method == 'CompleteAnnouncedTransfer' ||
            method == 'CompleteAttendedTransfer' || 
            method == 'SendToVoicemail' ||
            method == 'BlindTransfer' || 
            method == 'CompleteExternalAnnouncedTransfer' ||
            method == 'CompleteExternalAttendedTransfer'
          ) {
          this.tmQueueService.releaseLocks().subscribe();
          let id =  this.queueService.getTransferInteractionID()
          this.mainController.saveVideoRecording(id);
        }
        if (
          method == 'AnnounceTransferToUser' ||
          method == 'AttendTransferToUser' ||
          method == 'AddUserToCall' ||
          method == 'AddNumberToCall' ||
          method == 'ExternalAnnounceTransfer' ||
          method == 'ExternalAttendTransfer'
        ) {
          if (data) {
            //this.transferCallID = data.Response.Data.InternalCallID;
            this.queueServices.setTransferCallID(data.Response.Data?.InternalCallID);
            if (method !== 'AddUserToCall') {
              //this.queueService.SetDisableHeader(false);
              //this.queueService.setCallID('');
            }
          }
        }
        if (method == 'StartGroupTransfer') {
          this.queueServices.setGroupTransferInteractionID(data.Response.Data.GroupTransferInteractionID);
        }
        if (this.showStep2) {
          this.displayStep2();
        } else {
          this.transferCompleted(
            this.noPostCallTimeout,
            this.waitingForCallToComplete,
            this.allowCancel,
            this.onlyComments
          );
          //callerHungUp = false;
          //agentHungUp = false;
          //this.dialerService.setCurrentTransferStep(0);
        }
        }, this.fun_errorCallback.bind(this)
      
    );
    }

    fun_errorCallback(errorCode, message) {
        //function () {
            //this.transferProcessing = false;
            this.queueServices.setistransferProcessing(false);
            //initAlertModal();

            this.confirmDialogComponent
                .confirmdialog('', 'Error Occurred while transfering the call, Kindly cancel and initiate the call transfer, Reason: ' + errorCode , 'OK', '')
                .then((confirmed) => {
                    if (confirmed) {

                    }

                })
                .catch(() =>
                    console.log(
                        'User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'
                    )
                );

            //alertModal.open(message);
        //}
    }

  // complete attended internal
  attendTransfer(userid) {
    //interactionService.CompleteAttendedTransfer({ userID: userid }, function () {
    //	transferCompleted(false, false, false, true);
    //}, function (errorCode, message) {
    //	transferProcessing = false;
    //	initAlertModal();
    //	alertModal.open(message);
    //});
    //const callID = this.queueServices.getCallID();
    var callID = '';
      if (this.dialerService.getIsFreeDialer()) {
          callID = this.queueServices.getChildCallID();
      }
      else {
          callID = this.queueServices.getCallID();
      }
    this.tmQueueService.CompleteAttendedTransfer(callID, userid).subscribe(data => {
      this.transferCompleted(false, false, false, true);
    });
  }

  displayStep2() {
    this.dialerService.setisCallTransferstarted(true);
    this.openAnnouncedTransfer();
    //this.Showdisplay2 = true;
    //var data = this.controller().transferDetails();
    //$(this._cl_viewElement).removeClass('TransferStep1 TransferStep3').addClass('TransferStep2');
    //this.title((data != null && data.hasOwnProperty('typeName')) ? data.typeName : 'Add to Conference');
    //var isAdd = (this.title().indexOf('Add ') == 0);
    //isGroup = data.type == 'groupAnnounced' || data.type == 'groupAttended';
    //step2Hdr1Text.text('Recipient: ' + ((data != null && data.hasOwnProperty('name')) ? data.name : 'Third Party'));
    //step2Hdr2Text.text('On Call: ' + getUserName());
    //step2ToggleState.text('On with Transfer');
    //step2ToggleCaller.text('');
    //step2ToggleBtn.enabled(false);
    //step2AgentText.text(isGroup ? 'You may complete the transfer<br />once the recipient is on the line.' : 'When you are ready,<br />choose one of the following options.');
    //step2CompleteBtn.enabled(false);
    //step2CompleteBtn.label('Complete ' + (isAdd ? 'Add' : 'Transfer'));
    //step2CompleteBtn.tooltip((isAdd) ? 'Add the recipient to the conference call.' : 'Transfer the user to the recipient.  If Announced, you will be disconnected.  If Attended, you will stay on the line.');
    //step2ResumeBtn.label(isAdd ? 'Cancel Add' : 'Cancel Transfer');
    //step2ResumeBtn.tooltip((isAdd) ? 'Cancel the add and resume your call with the user.' : 'Cancel the transfer and resume your call with the user.');
    //step2VoicemailBtn.visible(data != null && data.type != "externalAttended" && data.type != "externalAnnounced" && data.type != 'externalAdd' && !isGroup);
    //step2VoicemailBtn.enabled(true);
    //setCallerDisplay(callerHungUp);
    //$(step2AgentText._cl_viewElement).removeClass('flashing');
    //step1.visible(false);
    //step3.visible(false);
    //transferCallID = null;
    //onWithCaller = false;
    //pendingToggle = false;
    //internalCallStart = true;
    //if (this._qbr_modal != null) {
    //	this._qbr_modal.contentView().width(350);
    //	this.cl().main().mainController().phoneController().isTransferViewActive(true);

    //	if (this.cl().main().mainController().phoneController().externalSystem())
    //		this._qbr_modal.contentView().alignX('right').alignY('top').x(-10).y(145);
    //}
    //this.width(350).height(420);
    //step2.visible(true);
  }

  transferCompleted(noPostCallTimeout, waitingForCallToComplete, allowCancel, onlyComments) {
    //if (cls.cl().main().mainController().activeController() == "Dialog" && !currOptions.RelatedCall) {
    //cls.QBRSecurity().setServerSyncProp('RecordLock', null);
    //cls.QBRSecurity().setServerSyncProp('CaseLocks', null);
    const dialogController = true; // im.DialogController.instance();
    if (dialogController) {
      /* CHAT
			// Internal Blind/Announced/Attended
			if (interactionMediaType == "Chat") {
				var msg = { type: "Transfer", text: "" };
				var message = JSON.stringify(msg);
				textChatView.getChannel().sendMessage(message);
				textChatView.saveChatDetails();
			}
			if (interactionMediaSubType == "video" || interactionMediaSubType == "audioonly") {
				videoChatView.onLeave();
			}


			// Voicemail
			if (interactionMediaType == "Chat" || interactionMediaSubType == "video" || interactionMediaSubType == "audioonly") {
					textChatView.backToQueue();
					twilioChatService.GetQueuePosition({
						channelSID: callSid, queue: queueName
					}, function (response) {
						queuePosition = response.queuePosition;
						var msg = {
							type: "Position", text: "Due to InActivity Chat is disconnected and you are in " + queuePosition + " position in the queue.Please wait for your turn"
						};
						var message = JSON.stringify(msg);
						textChatView.getChannel().sendMessage(message);
						textChatView.saveChatDetails();
					});
					cls.callCompleted(true);
					cls.view().disableButtons();
					transferPrompt.close();
					transferPromptStageTwo.close();
					showOutboundTransferPrompt(true, false, true);
				}
				else {
					cls.saveChanges(function () {
						interactionService.SendToVoicemail({ userID: data.id }, function () {
							//prompt for comments
							cls.callCompleted(true);
							cls.view().disableButtons();
							transferPrompt.close();
							transferPromptStageTwo.close();
							showOutboundTransferPrompt(true, false, true);
						}, function (errorCode, message) {
							im.UIAlert.open(message);
						});
					}, function (errorCode, message) {
						im.UIAlert.open(message);
					}, false);
				}
			*/

      if (waitingForCallToComplete) {
        this.fun_waitingForCallToComplete(true);
      } else {
        this.mainController.callCompleted(noPostCallTimeout);
      }
      //dialogController.view().disableButtons();
      this.waitForTransferSubmit(onlyComments);
      //this.displayStep3(true, dialogController.view().getNotes(), allowCancel, onlyComments, currOptions.RequireNotes);
      this.displayStep3(true, '', allowCancel, onlyComments, false);
    }
    //} else {
    //	var phoneController = self.cl().main().mainController().phoneController();
    //	if (waitingForCallToComplete) {
    //		phoneController.waitingForCallToComplete(true);
    //	} else {
    //		phoneController.callEnded(true);
    //	}
    //	phoneController.waitForTransferSubmit(onlyComments);
    //	self.view().displayStep3(true, null, allowCancel, onlyComments, currOptions.RequireNotes);
    //}
  }
  fun_waitingForCallToComplete(value) {
    if (typeof value === 'boolean') {
      this.waitingForCallToComplete = !!value;
      //return cls;
    }
    return this.waitingForCallToComplete;
  }
  callCompleted(noPostCallTimeout) {
    //check the call status one more time
    if (this.disconnectTimeout == null || this.statusFailures < this.disconnectTimeout)
      this.checkCallStatus(true, function () {
        this.resetCallStatuses();
      });
    else this.resetCallStatuses();
    const alreadyCompleted = false;
    const callIsConnected = false,
      //	callIsConnected = false;
      userDetailsData = null,
      callInProgress = false,
      callEnded = true,
      callers = null;
    //cls.view().stopCallTimer();
    //cls.view().stopHoldTimer();
    //cls.view().callCompleted(cls.view().visible());
    //cls.dispatchEvent(new im.CallEvent(im.CallEvent.CALL_ENDED));
    //cls.cl().main().mainController().lockStatus({
    //	label: 'Post-Call',
    //	value: 8
    //});
    //this.appService.setUserStatus(8, this.queueServices.getselectedQueueId());
    this.dialerService.setStatusMessage('Post-Call (Active)');
    if (this.waitingForCallToComplete) {
      this.waitingForCallToComplete = false;
      //if (this.waitingPrompt != null) this.waitingPrompt.close();
      this.confirmDialogComponent.cancel();
      this.confirmDialogComponent.closedialog();
      this.goToNextCall();
    } else {
      if (
        !alreadyCompleted &&
        this.noPostCallTimeout !== true &&
        this.dialerType != 'Manual' &&
        this.dialerType != 'External' &&
        this.postCallTimeout &&
        this.postCallTimeout > 0
      ) {
        this.postCallTimeoutRemaining = this.postCallTimeout;
        //requestMoreTimeBtn.visible(false);
        this.updatePostCallTimeout(true);
        this.postCallTimeoutAlert = true;
        clearInterval(this.postCallTimeoutInterval);
        this.postCallTimeoutInterval = setInterval(this.updatePostCallTimeout, 1000);
      } else if (this.noPostCallTimeout === true) {
        this.postCallTimeoutAlert = false;
        clearInterval(this.postCallTimeoutInterval);
      }
      //if a group transfer is pending and the call just ended, then alert the agent and block them from submitting this record
      if (this.isGroupTransfer && !this.groupTransferComplete) {
        //clearTimeout(groupTransferCheckTimeout);
        //im.UIAlert.open("<p>The transfer was canceled.</p><p>Press OK to " + (autoCall ? "go to the next record." : "return to the queue and choose a different record.") + "</p>", function () {
        //	goToNextCall();
        //});
      }
    }
  }

  waitForTransferSubmit(commentsOnly) {
    this.SUBMIT_CALL.subscribe(callDetails => {
      if (commentsOnly) {
        //&& e.data().disposition == 'notes'
        //regService.AddNotes({ notes: e.data().notes }, function (data) {
        //	clearInterval(this.postCallTimeoutInterval);
        //	//saveVideoRecording(data.InteractionID);
        if (this.waitingForCallToComplete) {
          //if (waitingPrompt == null) {
          //	waitingPrompt = new im.UIAlert();
          //	waitingPrompt.destroyOnClose(false)
          //		.continueLabel('Hang Up');
          //}
          //waitingPrompt.open('Waiting for you to finish the current call...', function () {
          //	cls.HangUpOnAttended(true);
          //	im.InteractionService.instance().Disconnect();
          //	cls.callCompleted();
          //});
          //this.dialerService.setCurrentTransferStep(3);
            
          this.confirmDialogComponent
            .confirmdialog('', 'Waiting for you to finish the current call...', 'Hang Up', '')
            .then(confirmed => {
                if (confirmed) {
                    var callID = '';
                    if (this.dialerService.getIsFreeDialer()) {
                        callID = this.queueServices.getChildCallID();
                    }
                    else {
                        callID = this.queueServices.getCallID();
                    }
                this.tmQueueService
                    .Disconnect(callID, this.queueServices.getGroupTransferInteractionID())
                  .subscribe(data => {
                    //saveVideoRecording(data.InteractionID);
                    //this.goToNextCall();
                      
                     // this.mainController.callEnded_phnctrl(null,null,null);
                   
                  });
                  this.mainController.setUnmappedCaseID('');
                  this.mainController.setUnmappedUserID('');
                  this.mainController.setIsCaseUserUnmapped(null);
                  this.mainController.setIsUnknownContact(false);
                  this.mainController.callCompleted(false);
                  callerHungUp = false;
                  agentHungUp = false;
                  this.dialerService.setCurrentTransferStep(0);
                  this.currTransfer = null;
                  this.queueServices.setistransferProcessing(false);
              } else {
                //Reject the call
              }
            })
            .catch(() =>
              console.log(
                'User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'
              )
            );
        } else this.goToNextCall();
        //});
      } else {
        const transferData = ''; //e.data();
        //transferData.userData = userInfoController ? userInfoController.getData() : {};
        //const callID = this.queueServices.getCallID();
          var callID = '';
          if (this.dialerService.getIsFreeDialer()) {
              callID = this.queueServices.getChildCallID();
          }
          else {
              callID = this.queueServices.getCallID();
          }
        const queueID = this.queueServices.getselectedQueueId();
        this.tmQueueService.CallTransferred(callID, queueID,this.isFreeDialer).subscribe(data => {
          //saveVideoRecording(data.InteractionID);
          this.goToNextCall();
        });
          //this.mainController.callCompleted(true);
        //this.mainController.callCompleted(false);
      }
    });
  }

  goToNextCall() {
      //if (this.dialerService.getIsFreeDialer()) {
      //    this.clearvalues();
      //    this.submitandTransfer();
      //}
      //else {
      
          this.clearvalues();
          this.submitandTransfer();
      //}
  }
  submitandTransfer() {
        //callerHungUp = false;
        //agentHungUp = false;
        //this.dialerService.setCurrentTransferStep(0);
        //this.dialerComponent.endCall.emit();
        this.bsModalRef.hide();
        this.Showdisplay2 = false;
        const returnData = {
            activityID: this.activityId,
            actionItem: this.actionItemToReturn,
            isExternalTransfer: this.selectedTab == 'External',
            queueType: this.queueType,
            transferCaseID: this.transferCaseID,
            triggerType: 'PostTransfer'
        };
        this.currTransfer = null;
       
        this.queueServices.setistransferProcessing(false);
        this.mainController.setSaveChanges(true);
        this.tmQueueService.setTransfer_SUBMIT_CALL(returnData);
    }
    clearvalues() {
        this.mainController.setUnmappedCaseID('');
        this.mainController.setUnmappedUserID('');
        this.mainController.setIsCaseUserUnmapped(null);
        this.mainController.setIsUnknownContact(false);
    }
  getNextCallDetails(skip, allowRedial, stayOnPage) {
    const queueID = this.queueServices.getselectedQueueId();
    //isRedial = false;
    //groupTransferComplete = false;
    //if (stayOnPage) {
    //	isRedial = true;
    //	if (dialerType == "Predictive")
    //		cls.redirect('Dialog/' + actionItemID + '-redial', null, true);
    //	else
    //		cls.redirect('Dialog/' + queueID + '-redial_' + (userID || '0') + '-' + caseID, null, true);
    //} else if (allowRedial && !inbound && dialerType != "Keypad") {
    //	//if the call was dropped, ask the user if they would like to re-dial the same user
    //	if (redialAlert == null) {
    //		redialAlert = new im.UIAlert();
    //		redialAlert.continueLabel('Yes').cancelLabel('No').destroyOnClose(false);
    //	}
    //	redialAlert.open('Would you like stay on this record?', function () {
    //		isRedial = true;
    //		if (dialerType == "Predictive" || dialerType == "Progressive")
    //			cls.redirect('Dialog/' + actionItemID + '-redial', null, true);
    //		else
    //			cls.redirect('Dialog/' + queueID + '-' + userID + '-' + caseID, null, true);
    //	}, function () {
    //		goToNextCall(skip, false);
    //	});
    //} else if (lastqueue != null) {
    //	if (!autoAdvanceEnabled) {
    //		//if Submit & Pause, then go away
    //		cls.view().reset(false, false);
    //		cls.cl().main().mainController().setStatusAway(lastqueue);
    //	} else {
    //		//if we came here from another queue, then check where we should go next
    //		dataService["GetNextActionItem"]({ queueID: lastqueue }, function (response) {
    //			if (inbound)
    //				//if this is an inbound queue (presumably a blended queue), then redirect to the next record
    //				cls.redirect("/Dialog/" + response, null, true);
    //			else {
    //				//otherwise we might need to reload the UI, so force a reload of the page
    //				cls.view().reset(false, false);
    //				window.location.assign(window.location.protocol + "//" + window.location.host + window.location.search + (window.location.search ? "&" : "?") + "temp=1#!/" + (window.location.hash.split('/')[1]) + "/Dialog/" + response);
    //			}
    //		}, function (errorCode, message) {
    //			cls.cl().main().mainController().profileStatus().setAgentStatus(6);
    //			cls.view().reset(false, false);
    //			window.location.assign(window.location.protocol + "//" + window.location.host + window.location.search + (window.location.search ? "&" : "?") + "temp=1#!/" + (window.location.hash.split('/')[1]) + "/Queue/" + lastqueue);
    //		});
    //	}
    //} else if (dialerType == "Power" || dialerType == "Preview" || dialerType == "Progressive" || dialerType == "Predictive" || dialerType == "AutomatedInbound" || dialerType == "Keypad") {
    //cls.view().reset(false, false);
    //tabController.reset();
    //reloadCallHistoryTab(-1); // ONV-535
    //callFailureController.hide();
    //dialogStatusHolder.visible(false);
    //if (autoAdvanceEnabled || dialerType == "Keypad") {
    //	if (dialerType == "Progressive" || dialerType == "Predictive") {
    //		cls.redirect('Dialog/' + queueID + '-auto');
    //	} else if (dialerType == "AutomatedInbound") {
    //cls.redirect('Dialog/' + queueID + '-inbound_auto');
    return queueID + '-inbound_auto';
    //		} else {
    //			var method = skip ? "SkipActionItem" : "GetNextActionItem", params = skip ? { item: actionItemID } : { queueID: queueID, skipUser: userID };
    //			dataService[method](params, function (response) {
    //				cls.redirect('Dialog/' + response, null, true);
    //			}, function (errorCode, message) {
    //				cls.cl().main().mainController().profileStatus().setAgentStatus(6);
    //				im.UIAlert.open("Unable to get the next record: " + message);
    //			});
    //		}
    //	} else {
    //		cls.cl().main().mainController().setStatusAway();
    //	}
    //} else
    //	cls.redirect('/');
  }
  displayStep3(isTransfer, notes, allowCancel, onlyComments, requireNotes) {
    //console.warn("TransferView.displayStep3(" + isTransfer + ', ' + notes + ', ' + allowCancel + ', ' + onlyComments + ', ' + requireNotes + ")");
    //var data = this.controller().transferDetails();
    //$(this._cl_viewElement).removeClass('TransferStep1 TransferStep2').addClass('TransferStep3');
    //this.title('Wrap Up: ' + getUserName());
    this.commentsOnly = !!onlyComments;
    //step3HdrText.text(commentsOnly ? 'Please add notes about the call.' : 'Please choose a call disposition,<br />and add notes if desired.');
    //step3DispositionSelect.selectedOption(isTransfer ? { value: 7 } : 0);
    //step3DispositionSelect.enabled(!isTransfer);
    //step3DispositionSelect.validityChanged(true);
    //step3NotesField.value(notes || '');

    this.commentsOnly = true; //hardcoded
    if (this.commentsOnly && !requireNotes)
      //|| step3DispositionSelect._cl_options.length == 2
      this.eStep3SubmitBtnClickHandler();
    else {
      //step3CancelBtn.enabled(!!allowCancel);
      //step3DispositionSelect.visible(!commentsOnly);
      //step1.visible(false);
      //step2.visible(false);
      //if (this._qbr_modal != null) {
      //	this._qbr_modal.contentView().width(350);
      //	if (this.cl().main().mainController().phoneController().externalSystem())
      //		this._qbr_modal.contentView().alignX('right').alignY('top').x(-10).y(145);
      //}
      //this.width(350).height(350);
      //step3.visible(true);
    }
  }
  //currentStep = function () {
  //	if (step1.visible())
  //		return 1;
  //	if (step2.visible())
  //		return 2;
  //	if (step3.visible())
  //		return 3;
  //	return null;
  //}
  eStep3SubmitBtnClickHandler() {
    //cls.cl().main().mainController().phoneController().isTransferViewActive(false);
    this.queueServices.setisTransferViewActive(false);
    //if (step3DispositionSelect.visible() && step3DispositionSelect.enabled() && (step3DispositionSelect.selectedOption() == null || step3DispositionSelect.selectedOption().value == -1)) {
    //	step3DispositionSelect.validityChanged(false);
    //} else {
    //self.controller().dispatchEvent(im.TransferController.SUBMIT, {
    //	disposition: this.commentsOnly ? 'notes' : step3DispositionSelect.value(),
    //	notes: step3NotesField.value()
    //});

    this.SUBMIT_CALL.emit();
    this.hide(false);
    //self.controller().hide();
    this.transfer_Hide();
    //}
  }

  transfer_Hide() {
    this.Showdisplay2 = false;
    this.Showdisplay3 = false;
    this.Showdisplay1 = false;
  }

  checkCallStatus(force, callback) {
    //if (!callEnded)
    //	setTimeout(function () {
    //		if (force === true || !callEnded)
    //			a5.cl.plugins.InactivityLogout.instance().resetTimer();
    //		interactionService.GetUpdate(function (response) {
    //			statusFailures = 0;
    //			if (callIsConnected && response.OutgoingCallStatus == "in-progress")
    //				groupTransferComplete = true;
    //			if (response.Callers != null && response.Callers.length > 0) {
    //				if (response.Callers[0].OnHold == false && cls.cl().main().mainController().transferController().isTransferCompleteProcessing()) {
    //					cls.view().stopHoldTimer();
    //					cls.view().stopHoldTimer()
    //					cls.cl().main().mainController().phoneController().toggleHoldUI(true);
    //				}
    //			}
    //			updateCallStatus(response, force);
    //			if (typeof callback == "function")
    //				callback.call(cls);
    //		}, function (errorCode, message) {
    //			statusFailures++;
    //			if (statusFailures == disconnectTimeout) {
    //				if (interactionType == 'InboundVideoChat' || interactionType == 'InboundTextChat') {
    //					textChatView.chatEnded(im.CallStatus.COMPLETED, im.CallStatus.FAILED);
    //				}
    //				cls.callCompleted();
    //			} else if (statusFailures < disconnectTimeout) {
    //				checkCallStatus(force, callback);
    //			}
    //		});
    //	}, force ? 0 : 1000);
  }

  resetCallStatuses() {
    //parentCallStatus = null;
    //outgoingCallStatus = null;
    //statusFailures = 0;
  }

  updatePostCallTimeout(skipDecrement) {
    //if (!skipDecrement)
    //	postCallTimeoutRemaining--;
    //if (postCallTimeoutRemaining <= 0) {
    //	dataService.PostCallTimedOut();
    //	postCallTimeoutAlert.visible(false);
    //	clearInterval(postCallTimeoutInterval);
    //	autoAdvanceEnabled = false;
    //	var success = submitData(true, postCallTimeoutFailure);
    //	if (!success)
    //		postCallTimeoutFailure();
    //}
    //postCallTimeoutText.text('Warning: You have ' + postCallTimeoutRemaining + ' seconds to submit this record.');
    //if (postCallTimeoutRemaining <= postCallTimeout / 2)
    //	requestMoreTimeBtn.visible(true);
  }

  eStep2ResumeBtnClickHandler = function () {
    this.completeTransferClicked = false;
    //cls.cl().main().mainController().phoneController().isTransferViewActive(false);
    this.queueServices.setisTransferViewActive(false);
    //self.controller().toggleHoldUI(true);
    if (!callerHungUp) {
      this.eResumeCallHandler(true);
      this.company = this.webStorageService.getItemFromSessionStorage('company');
       if(this.company == 'Baycare' || this.company == 'Parkland'){
        const loginParams = this.webStorageService.getItemFromSessionStorage('loginParams'); 
        if(loginParams){
          this.allowDifferentUserCase = (loginParams?.AllowDifferentUserCase?.toLowerCase() === 'true');
          if(this.allowDifferentUserCase){
            let tempDifferentUserCases = this.queueService.getOtherUserCasesForCancelTransfer();
            if(tempDifferentUserCases && tempDifferentUserCases.length > 0){
              this.queueService.setValueChildChk(true);
              this.flexStore.set('CaseCreatedForDifferentUser', JSON.stringify(tempDifferentUserCases));
            }
            this.appService.setIsCasesReload(true);
          }
        }
       }
      

      
      //self.dispatchEvent(im.CallEvent.RESUME, { isGroup: this.isGroup, step2Cancel: true });
    } else if (!agentHungUp) {
      this.eResumeCallHandler(true);
      //self.dispatchEvent(im.CallEvent.RESUME, { isGroup: isGroup, step2Cancel: true });
      //cls.cl().main().mainController().endCall();
      this.dialerService.setcallEnded(true);
      //self.controller().hide();
      this.hide(false);
    } else {
      //cls.cl().main().mainController().endCall();
      //self.controller().hide();
      this.dialerService.setcallEnded(true);
      this.hide(false);
    }

    //this.mainController.setenableActiveCallButtons();
    //this.resetActiveDialerButtons();
    callerHungUp = false;
    agentHungUp = false;
    this.dialerService.setCurrentTransferStep(0);
    this.queueServices.setistransferProcessing(false);
    this.dialerService.setisCallTransferstarted(false);
    this.mainController.setcallTransferred(false);
    this.currTransfer = null;
    this.dialerComponent.toggleHold.emit({ val: false, shouldcallapi: false });
  };

  eResumeCallHandler = function (step2Cancel) {
    const currTransfer = this.queueServices.getCurrentTransferData();

    //var queueType = cls.cl().main().mainController().getQueueType();
    //if (queueType != 'Outbound' && queueType != 'Search') {
    //	var wrapperController = im.UserInfoWrapperController.instance();
    //	if (wrapperController) {
    //		wrapperController.showChangeUserBtn(true);
    //	}
    //}

    const data = currTransfer;
   // const callID = this.queueServices.getCallID(); //(data != null && data.hasOwnProperty('id')) ? data.id : null;
      var callID = '';
      if (this.dialerService.getIsFreeDialer()) {
          callID = this.queueServices.getChildCallID();
      }
      else {
          callID = this.queueServices.getCallID();
      }
    this.tmQueueService
      .resumeCall(callID, true, step2Cancel, this.queueServices.getGroupTransferInteractionID())
      .subscribe(
        response => {
          this.cancelTransferHold();
          if (!data.skipHide) this.hide(step2Cancel);
        },
        function (errorCode, message) {
          console.log(message);
        }
      );
  };

  cancelTransferHold = function () {
    //holdPending = false;
    //im.InteractionService.instance().GetHoldTime(function (response) {
    //	im.DialogController.instance().stopHoldTimer(response.Time);
    //});
  };

  getExternalNumbersByActivity() {
    const queueID = this.queueServices.getselectedQueueId();
    this.tmQueueService.getExternalNumbersByActivity(queueID).subscribe(data => {
      //this.externalUsers = data.Response.Data;
      this.externalUsers = data?.Response?.Data?.filter(item=> item.ExternalTransferEnabled==true);
    });
  }
  setSelectedTab(tab) {
    if (tab.index >=0) {
      this.selectedTab = this.tabView.tabs[tab.index].header;
      //  console.log('setselectedtab' + tab);
      this.resettimer();
      if (this.selectedTab == 'Internal') {
        this.getInternalTransferDetails();
      } else if (this.selectedTab == 'External') {
        this.getExternalNumbersByActivity();
      } else if (this.selectedTab == 'Groups') {
        this.getGroupDetails();
      }
    } else {
      this.selectedTab = tab;
    }
  }

  resettimer() {
    window.clearTimeout(this.updategrpTimer);
    window.clearTimeout(this.updateTimer);
  }
  resetActiveDialerButtons() {
    const data: any = {};

    data.showDialer = true;
    data.CustomControlEnabled = true;
    data.muteBtn_enabled = true;
    data.keypadBtn_enabled = true;
    data.holdBtn_enabled = true;
    data.hangUpBtn_enabled = true;
    data.transfersBtn_enabled = true;
    data.conferenceBtn_enabled = true;
    this.dialerService.setCustomShowDialer(data);
  }

  sendVoiceMailClickHandler = function () {
    this.eTransferHandler(this.currTransfer, 'voicemail');
  };
  isAgentOnCall = function (userID) {
    const activecallers = this.queueServices.getactivecallers();

    if (typeof userID === 'number' && activecallers != null && activecallers.length > 0) {
      return this.isInArray(activecallers, userID, 'UserID');
    }
    return false;
  };
  isInArray = function (array, search, propName) {
    return this.getArrayIndex(array, search, propName) != -1;
  };

  getArrayIndex = function (array, search, propName) {
    for (let i = 0; i < array.length; i++) {
      if (propName != null) {
        if (array[i][propName] == search) {
          return i;
        }
      } else if (array[i] == search) {
        return i;
      }
    }
    return -1;
  };
  getEnableDetail(user: any, transfertype: any) {
    let enable = false;
    //StatusID == 1 ->LoggedIn;  5 ->oncall; 6  ->InQueue;  17 ->ExternalAvailable;  4 ->Resumed; !this.isAgentOnCall(user.UserID)->not OnCall
    if (transfertype == 'blind') {
      enable = (user.StatusID == 1 || user.StatusID == 6 || user.StatusID == 4) && !this.isAgentOnCall(user.UserID);
    } else if (transfertype == 'announced') {
      enable = user.StatusID != 5 && !this.isAgentOnCall(user.UserID);
    } else if (transfertype == 'attended') {
      enable = user.StatusID != 5 || !this.isAgentOnCall(user.UserID);
    } else if (transfertype == 'add') {
      enable = user.StatusID != 5 && !this.isAgentOnCall(user.UserID);
    }

    return !enable;
  }

  isCallerOnCall(userid) {
    //var activecallers = this.queueServices.getactivecallers();
    if (this.callers == null || this.callers.length == 0) return false;

    let x, y;
    for (x = 0, y = this.callers.length; x < y; x++) {
      if (this.callers[x].UserID == userid) return true;
    }
    return false;
  }

  //Participant list start

  populateConferenceList = function () {
    const data = this.queueServices.getactivecallers();

    if (data == null) {
      return;
    }

    if (this.lastCallers != null) {
      if (JSON.stringify(data) == JSON.stringify(this.lastCallers)) return;
    }

    this.lastCallers = data;

    // Get Counts per User Type
    const counts = {
      User: 0,
      Agent: 0,
      ThirdParty: 0,
    };

    for (let i = 0; i < data.length; i++) {
      if(data[i].UserType != 'Manager') counts[data[i].UserType]++;
      if(data[i].OnHold) data[i].ishold = true; else data[i].ishold = false;
    }

    // this.callersUserCountText = counts.User + ' User' + (counts.User != 1 ? 's  ' : '  ');
    // this.callersInternalCountText = counts.Agent + ' Agent' + (counts.Agent != 1 ? 's  ' : '  ');
    // this.callersExternalCountText = counts.ThirdParty + '  External';

    this.callersUserCountText = counts.User + (counts.User > 1 ? 's  ' : '  ');
    this.callersInternalCountText = counts.Agent + (counts.Agent > 1 ? 's  ' : '  ');
    this.callersExternalCountText = counts.ThirdParty + (counts.ThirdParty > 1 ? 's  ' : '  ');

    //var itemCount = this.conferenceList.length;
    //var itemsToRemove = [];

    //// Update Existing Callers / Mark Disconnected Callers for Removal
    //	for (var i = 0; i < itemCount; i++) {
    //		var item = data[i];
    //	var callID = item.CallID;
    //	var callIndex = this.getArrayIndex(data, callID, 'CallID');
    //	if (callIndex != -1) {
    //		item.data(data[callIndex]);
    //		data.splice(callIndex, 1);
    //	} else {
    //		itemsToRemove.push(item);
    //	}
    //}

    // Remove Disconnected Callers
    //for (var i = 0; i < itemsToRemove.length; i++) {
    //	conferenceList.removeItem(itemsToRemove[i], true);
    //}

    //// Add New Callers
    //for (var i = 0; i < data.length; i++) {
    //	if (data[i].UserType != 'Manager') {
    //		conferenceList.addItem(new im.PhoneCallerListItem(data[i]));
    //	}
    //}

    callers = data;
    this.queueServices.setconferencelist(data);
  };

  HoldCall(data) {
    let activeconfcallers = this.queueServices.getconferencelist();

    if (!activeconfcallers) {
      activeconfcallers = this.queueServices.getactivecallers();
    }
    const callID = data.CallID;
    const callIndex = this.getArrayIndex(activeconfcallers, callID, 'CallID');
    if (callIndex != -1) {
      //item.data(data[callIndex]);
      //data.splice(callIndex, 1);
      if (!activeconfcallers[callIndex].ishold) {
        activeconfcallers[callIndex].ishold = true;
      } else {
        activeconfcallers[callIndex].ishold = false;
      }
    } else {
      //itemsToRemove.push(item);
    }

    if (activeconfcallers[callIndex].UserType == 'User') {
      this.ToggleHoldCallerUser(callID, activeconfcallers[callIndex].ishold);
    } else {
      this.ToggleHoldAgentUser(callID, activeconfcallers[callIndex].ishold);
    }

    callers = activeconfcallers;
    this.queueServices.setconferencelist(activeconfcallers);
  }
  ToggleHoldCallerUser(callID, ishold) {
      this.dialerComponent.toggleHold.emit({ val: ishold, shouldcallapi: true });
  }

  ToggleHoldAgentUser(callID, ishold) {
    if (ishold) {
        this.tmQueueService.holdCall(callID, false).subscribe(data => {
        console.log(data);
      });
    } else {
        this.tmQueueService.resumeCall(callID, false, false, '').subscribe(data => {
        console.log(data);
      });
    }
  }

  DisconnectCall(data) {
    const callID = data.CallID;
    this.tmQueueService
      .CancelCall(false, callID, this.queueServices.getGroupTransferInteractionID())
      .subscribe(data => {
        console.log(data);
      });
    this.RemovecallerfromList(callID);
    //this.populateConferenceList();
  }

  RemovecallerfromList(callID) {
    const data = this.queueServices.getconferencelist();

    const callIndex = this.getArrayIndex(data, callID, 'CallID');
    if (callIndex != -1) {
      data.splice(callIndex, 1);
    } else {
      //itemsToRemove.push(item);
    }

    // Remove Disconnected Callers
    //for (var i = 0; i < itemsToRemove.length; i++) {
    //	conferenceList.removeItem(itemsToRemove[i], true);
    //}
    //console.log(data);
    //console.log(callers);
    callers = data;
    this.queueServices.setconferencelist(data);
  }

  getCallersList() {
    const data = this.queueServices.getconferencelist();
    // console.log('caller list', callers);
    // console.log('caller list', data);
    return data;
  }

  formatPhoneNumber = function (number, country) {
    switch (country) {
      case 'US':
      default:
        number = number.replace(/\D/g, '');
        if (number.charAt(0) == '1') number = number.substring(1);
        if (number.length == 7) return number.substring(0, 3) + '-' + number.substring(3);
        if (number.length == 10)
          return '(' + number.substring(0, 3) + ') ' + number.substring(3, 6) + '-' + number.substring(6);
        if (number.length > 10)
          return (
            '(' +
            number.substring(0, 3) +
            ') ' +
            number.substring(3, 6) +
            '-' +
            number.substring(6, 10) +
            ' x' +
            number.substring(10)
          );
        return number;
    }
  };

  closepartcipantlistMenu() {
    //if (this.bsModalRef)
    //	this.bsModalRef.hide();
    //this.modalService = null;
    this.dialerComponent.hidemodal.emit();
    //showConference = false;
  }
  closepartcipantlist() {
    //if (this.bsModalRef)
    this.bsModalRef.hide();
    //this.modalService = null;
    this.dialerComponent.hidemodal.emit();
    //showConference = false;
  }
  //Participant list end

    getAgentStatuses() {
        //window.clearTimeout(this.updateTimer);
        return new Promise((resolve, reject) => {
            this.tmQueueService.getAgentStatuses().subscribe(data => {
                resolve(data.Response.Data);
                //this.updateTimer = setTimeout(this.getAgentStatuses.bind(this), 3000);
            })

        });
    }
}
